import React, { Component } from "react";
import { connect } from "react-redux";
import HomeCard from "../../Home/HomeCard";
import SchoolIcon from "../../../Assets/img/library.png";
import ProfileIcon from "../../../Assets/img/gender-neutral-user.png";
import PasswordIcon from "../../../Assets/img/lock.png";
import LogOutIcon from "../../../Assets/img/export.png";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class ProfileOptions extends Component {
  logout = () => {
    this.props.dispatch({
      type: "user/LOGOUT",
    });
  };

  render() {
    return (
      <div className="container py-4">
        <div className="row">
          <div className="col-4 px-2">
            <HomeCard
              title="School Profile"
              to="/aboutSchool"
              iconImage={SchoolIcon}
            />
          </div>
          <div className="col-4 px-2">
            <HomeCard
              title="My Profile"
              to="/profileDetails"
              iconImage={ProfileIcon}
            />
          </div>
          <div className="col-4 px-2">
            <HomeCard
              title="Change Password"
              to="/password"
              iconImage={PasswordIcon}
            />
          </div>
          <div className="col-4 px-2"></div>
          <div className="col-4 px-2">
            <HomeCard
              title="Log Out"
              onClickButton={this.logout}
              iconImage={LogOutIcon}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(ProfileOptions);
